import React from "react";
import Testimonials from "../Testimonials";

export default function CustomerStoriesSection() {
  return <Testimonials />;
}